import { Injectable } from '@angular/core';
import { ApplicationStatusRetrievalService } from 'src/app/shared/services/application-status-retrieval.service';
import { SearchResponse } from 'src/app/angular-elements/producer/interfaces/search-response.interface';
import { LoggedInUserInformationService } from '@ptl/account-management';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, Subject, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubmittedApplicationListingService {

  retrievedAppsSubject: Subject<SearchResponse> = new BehaviorSubject(null);
  public retrievedApps$: Observable<SearchResponse> = this.retrievedAppsSubject.asObservable();;

  constructor(
    private appStatusRetrieveService: ApplicationStatusRetrievalService,
    private loggedInUserService: LoggedInUserInformationService
  ) { }

  async getApps(): Promise<void> {
    const user = this.loggedInUserService.getUserData();

    const appResponse = await this.appStatusRetrieveService.getApplications({
      // firstName: user.basicUserInfo.firstName,
      // lastName: user.basicUserInfo.lastName,
      pageNumber: 0,
      countPerPage: 10
    });

    if (!(appResponse instanceof HttpErrorResponse)) {
      this.retrievedAppsSubject.next(appResponse);
    } else {
      this.retrievedAppsSubject.next(null);
    }
  }
}
